import { ItemText, Main } from 'components/ActionStyles/ActionStyles'
import AntdAvatar from 'components/Avatar'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ResumeDownload from 'components/ResumeDownload'
import ResumePreview from 'components/ResumePreview'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import {
  DropBtn,
  DropDown,
  HeaderFlexATS,
  TestDetailsFlexNew,
  ThreeDotsDiv,
  TopFlexNew,
  TopRightFlexATS,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/style'
import React from 'react'

import { Col, Row } from 'antd'
import CallIcon from 'components/icons/CallIcon'
import MailIcon from 'components/icons/MailIcon'
import {
  CollegeName,
  InfoSectionNew,
  StudentName,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/style'
import { useSelector } from 'react-redux'
import ActionDropdown from '../ActionDropdown'
import PreviousRound from '../PreviousRound'

const CandidateViewDrawer = ({
  candidateDrawer,
  setCandidateDrawer,
  singleRoleData,
  scoreDetail,
  currentSelection,
  currentTimeDetails,
  getCandidateList,
  canEditScore,
  parameterDetail,
  selectedTime,
}) => {

  const candidateDetails = useSelector(
    state => state?.corporate?.candidateDetails
  )

  const items = [
    {
      key: 'download',
      label: (
        <ResumeDownload
          triggerButton={<ItemText weight={400}>Download Resume</ItemText>}
          studentDetails={candidateDetails}
          roleId={singleRoleData?.id}
        />
      ),
    },
  ]

  const onClose = () => {
    setCandidateDrawer(false)
  }

  const content = () => {
    return (
      <Row>
        <Col span={12}>
          <HeaderFlexATS row spaceBetween centerVertically>
            <TopRightFlexATS row spaceBetween centerVertically>
              <TopFlexNew row centerVertically>
                <AntdAvatar
                  size={90}
                  src={candidateDetails?.profileUrl}
                  IconName={candidateDetails?.firstName
                    ?.toUpperCase()
                    ?.charAt(0)}
                />
                <InfoSectionNew column center>
                  <StudentName>
                    {candidateDetails?.firstName} {candidateDetails?.middelName}{' '}
                    {candidateDetails?.lastName}
                  </StudentName>
                  <CollegeName>
                    <MailIcon /> {candidateDetails?.admin?.email}
                  </CollegeName>
                  <CollegeName>
                    <CallIcon /> {candidateDetails?.admin?.country_code} -{' '}
                    {candidateDetails?.admin?.phone_number}
                  </CollegeName>
                </InfoSectionNew>
              </TopFlexNew>
              {!candidateDetails?.isExpCandidate && (
                <Flex row centerVertically>
                  <TestDetailsFlexNew column></TestDetailsFlexNew>
                </Flex>
              )}
            </TopRightFlexATS>

            <ThreeDotsDiv>
              <Main>
                <DropDown menu={{ items }} trigger={['click']}>
                  <DropBtn>
                    <VerticalThreeDots />
                  </DropBtn>
                </DropDown>
              </Main>
            </ThreeDotsDiv>
          </HeaderFlexATS>

          <div>
            {/* Document view, matching every other resume surface. */}
            <ResumePreview
              cvUrl={candidateDetails?.cvUrl}
              studentId={candidateDetails?.id}
              roleId={singleRoleData?.id}
              candidateName={`${candidateDetails?.firstName || ''} ${
                candidateDetails?.lastName || ''
              }`.trim()}
            />
          </div>
        </Col>
        <Col span={6} style={{ padding: '8px' }}>
          <PreviousRound scoreDetail={scoreDetail} />
        </Col>
        <Col span={6} style={{ padding: '8px' }}>
          <ActionDropdown
            candidateDetails={candidateDetails}
            singleRoleData={singleRoleData}
            currentSelection={currentSelection}
            setCandidateDrawer={setCandidateDrawer}
            currentTimeDetails={currentTimeDetails}
            getCandidateList={getCandidateList}
            scoreDetail={scoreDetail}
            canEditScore={canEditScore}
            parameterDetail={parameterDetail}
            selectedTime={selectedTime}
          />
        </Col>
      </Row>
    )
  }

  return (
    <Drawer
      width="100%"
      height={'100%'}
      placement="right"
      title={'Details of candidate'}
      visible={candidateDrawer}
      content={content()}
      onClose={onClose}
      closable
    />
  )
}

export default CandidateViewDrawer
